var map = {
	"./arms_1_1.png": "a966",
	"./arms_2_1.png": "89d6",
	"./arms_3_1.png": "daf6",
	"./arms_4_1.png": "316c",
	"./arms_5_1.png": "0d19",
	"./arms_6_1.png": "8717"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c49";